const descriptions = {
  Home: "Algostine builds custom software, AI systems and cloud infrastructure for businesses that need it to work at scale.",
  Services: "Software, AI, cloud and cybersecurity engineering services from Algostine.",
  Contact: "Tell us what you are building. Algostine replies within 24 hours from Noida, working with clients worldwide.",
};

export const pageTitle = (title, description) => {
  const pageDescription = description || descriptions[title] || `${title} from Algostine — software, AI and cloud engineering.`;
  document.title = `${title} | Algostine`;

  const setMeta = (selector, attribute, key, value) => {
    let meta = document.querySelector(selector);
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute(attribute, key);
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", value);
  };

  setMeta('meta[name="description"]', "name", "description", pageDescription);
  setMeta('meta[property="og:title"]', "property", "og:title", document.title);
  setMeta('meta[property="og:description"]', "property", "og:description", pageDescription);
  setMeta('meta[property="og:url"]', "property", "og:url", window.location.href);
  setMeta('meta[property="og:image"]', "property", "og:image", `${window.location.origin}/logo.png`);
  setMeta('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image");
  setMeta('meta[name="twitter:title"]', "name", "twitter:title", document.title);
  setMeta('meta[name="twitter:description"]', "name", "twitter:description", pageDescription);
  return document.title;
};
